<template>
  <div class="mt-n4">
    <div v-if="getGoalieLoader">
      <v-col cols="12" md="10" sm="10" class="mx-auto">
        <v-skeleton-loader
            :loading="getGoalieLoader"
            class="ma-2"
            type="card@2"
            elevation="2"
        >
        </v-skeleton-loader>
      </v-col>
    </div>

    <div class="startinggoliessection" v-else>
      <v-row class="m-0">
        <v-col
            cols="12"
            md="6"
            sm="12"
            class="mx-auto"
            v-for="item in goaliesData.data"
            :key="item._id"
        >
          <div class="startinggolinner">
            <base-title-bar
                elevation="2"
                class="text-center titlegolis"
                color="#72C604"
                :label="`${item.AwayTeamCity} ${item.AwayTeamName} at ${item.HomeTeamCity} ${item.HomeTeamName}`"
                icon="mdi-hockey-sticks"
                height="50"
                textProp="pt-2 text-subtitle-1 white--text"
            />
            <div class="dategolis">
              <div class="text-center">
                <span>{{ item.DateTime | dayFormat }} EST</span>
              </div>
            </div>

            <!--//* goalies cards.. -->
            <v-card class="mx-auto goalies-design" elevation="2">
              <v-card-text>
                <v-row>
                  <!-- //! AwayTeam goalie  -->
                  <v-col cols="12" md="6" sm="6">
                    <div class="teambox-golis leftteams">
                      <div class="goliplayer-img">
                        <v-avatar width="80" tile size="100" color="#ECEFF1">
                          <img :src="item.AwayPlayerLogo"/>
                        </v-avatar>
                      </div>
                      <div class="golidetail">
                        <span class="body-2 font-weight-bold playernamgoli"
                        >{{ item.AwayFirstName }}
                          {{ item.AwayLastName }}</span
                        >
                        <span
                            v-if="item.AwayConfirmed == 'false'"
                            class="body-2 red--text font-weight-bold"
                        >
                          Unconfirmed <br/>
                        </span>
                        <span
                            v-else-if="item.AwayConfirmed == 'true'"
                            class="body-2 green--text font-weight-bold"
                        >
                          Confirmed <br/>
                        </span>
                        <span
                            class="caption linecombo font-weight-bold links"
                            @click.stop="getDepthChart(item.AwayTeamID)"
                        >
                          Line Combos <br/>
                        </span>
                      </div>
                      <div class="goli-temlogo">
                        <v-avatar
                            tile
                            width="80"
                            size="100"
                            color="#ECEFF1"
                            class="float-right"
                        >
                          <img :src="item.AwayTeamLogo"/>
                        </v-avatar>
                      </div>
                    </div>
                    <!-- <p class="pt-3 pt-md-0  text-center">No Goalie Details Yet.</p> -->
                  </v-col>

                  <!-- <v-divider vertical></v-divider> -->

                  <!-- //! HomeTeam goalie  -->
                  <v-col cols="12" md="6" sm="6">
                    <div class="teambox-golis righteams">
                      <div class="goli-temlogo">
                        <v-avatar tile width="80" size="100" color="#ECEFF1">
                          <img :src="item.HomeTeamLogo"/>
                        </v-avatar>
                      </div>
                      <div class="golidetail">
                        <span class="body-2 font-weight-bold playernamgoli"
                        >{{ item.HomeFirstName }}
                          {{ item.HomeLastName }}</span
                        >
                        <span
                            v-if="item.HomeConfirmed == 'false'"
                            class="body-2 red--text font-weight-bold"
                        >
                          Unconfirmed <br/>
                        </span>
                        <span
                            v-else-if="item.HomeConfirmed == 'true'"
                            class="body-2 green--text font-weight-bold"
                        >
                          Confirmed <br/>
                        </span>

                        <span
                            class="caption linecombo font-weight-bold links"
                            @click.stop="getDepthChart(item.HomeTeamID)"
                        >
                          Line Combos <br/>
                        </span>
                      </div>
                      <div class="goliplayer-img">
                        <v-avatar
                            tile
                            width="80"
                            size="100"
                            color="#ECEFF1"
                            class="float-right"
                        >
                          <img height="50%" :src="item.HomePlayerLogo"/>
                        </v-avatar>
                      </div>
                    </div>
                    <!-- <p class="pt-3 pt-md-0 text-center">No Goalie Details Yet.</p> -->
                  </v-col>
                </v-row>

                <v-sheet rounded class="my-2" color="#81C784">
                  <v-row justify="center" align="center">
                    <!-- away -->
                    <v-col md="4" align-self="center">
                      <p class="body-2 text-end">
                        Money Line :
                        <span class="font-weight-medium">
                          {{
                            item.AwayTeamMoneyLine ? item.AwayTeamMoneyLine : 0
                          }}
                        </span>
                      </p>
                    </v-col>

                    <!-- over under -->
                    <v-col md="4" align-self="center">
                      <p
                          class="body-2 text-center black--text font-weight-medium"
                      >
                        <span class="font-weight-regular">Over Under: </span>
                        {{ item.OverUnder ? item.OverUnder : 0 }}
                      </p>
                    </v-col>

                    <!-- home -->
                    <v-col md="4" align-self="center">
                      <p class="body-2 text-start">
                        Money Line :
                        <span class="font-weight-medium"
                        >{{
                            item.HomeTeamMoneyLine ? item.HomeTeamMoneyLine : 0
                          }}
                        </span>
                      </p>
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <!-- dialog -->
      <v-dialog v-model="dialog" max-width="1000">
        <v-card class="pa-2">
          <line-combination :depthChart="Arr"/>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn color="red darken-1" text @click="dialog = false">
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog ends -->
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import lineCombination from "@/components/Lists/lineCombination.vue";
import axios from "axios";

export default {
  name: "NhlDemoStartGoalies",
  components: {lineCombination},

  created() {
    this.$store.dispatch("NhlModule/fetchGoalies");
  },

  data: () => ({
    dialog: false,
    Arr: {},
  }),

  computed: {
    ...mapState("NhlModule", ["goaliesData"]),
    ...mapGetters("NhlModule", ["getGoalieLoader"]),
  },

  methods: {
    getDepthChart(teamId) {
      let obj = {
        TeamID: teamId,
        SportId: 3,
      };
      axios
          .post("https://api.fantasylineups.com/nhl/nhlgetTeamData", obj)
          .then((res) => {
            console.log(res.data);
            this.transformer(res.data);
          })
          .catch((err) => {
            console.error(err.message);
          });
      this.dialog = !this.dialog;
    },

    transformer(data) {
      let LWarr = [];
      let RWarr = [];
      let Carr = [];
      let PP1arr = [];
      let PP2arr = [];
      let LDarr = [];
      let RDarr = [];

      LWarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "LW";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      RWarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "RW";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      Carr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "C";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      LDarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "LD";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      RDarr = data.players[0].EvenStrengthLines.filter((player) => {
        return player.Position == "RD";
      }).sort((a, b) => a.LineNumber - b.LineNumber);

      PP1arr = data.players[0].PowerPlayLines.filter((player) => {
        return player.LineNumber == 1;
      });

      PP2arr = data.players[0].PowerPlayLines.filter((player) => {
        return player.LineNumber == 2;
      });

      this.Arr = {
        LWarr,
        RWarr,
        Carr,
        LDarr,
        RDarr,
        PP1arr,
        PP2arr,
        FullName: data.players[0].FullName,
        Jersey_Image: data.players[1].Jersy_Image,
        Key: data.players[0].Key,
        TeamID: data.players[0].TeamId,
      };

      console.log("Arr", this.Arr);
      return this.Arr;
    },
  }
};
</script>

<style scoped>
.links:hover {
  color: green;
  cursor: pointer;
}
</style>
